import get from 'lodash/get';
import { camelizeKeys } from 'humps';

/*
 * Turns the given `event` from event settings (which, on the back end, is a mix
 * of properties from the event and event setting models) into an object that
 * looks like the event-nav `event` bootstrap data. Matches the schema
 * expected by the `mergeEvents` entity merging function.
 *
 * See app/frontend/common/entities/event/index.js
 */
export const transformEvent = (event) => {
    let venueData = {};
    let eventSettingsData = {};
    const camelizedEvent = camelizeKeys(event);

    const {
        id,
        title,
        descriptionText: description,
        domain,
        customDomain,
        startTime,
        endTime,
        isRsvpOpen,
        autosave,
        published,
        pagePrivacyType,
        type: eventType,
        whiteLabel,
        hideFooter,
        isHub,
    } = camelizedEvent;

    if (camelizedEvent.venue) {
        venueData = {
            venueName: camelizedEvent.venue.name,
            address: camelizedEvent.venue.address,
            city: camelizedEvent.venue.city,
            zipCode: camelizedEvent.venue.postalCode,
            country: camelizedEvent.venue.country,
            state: camelizedEvent.venue.state,
        };
        eventSettingsData = {
            lat: camelizedEvent.venue.lat,
            lng: camelizedEvent.venue.lon,
            isRegistrationUpdatingEnabled: camelizedEvent.registrationUpdatingEnabled,
        };
    }

    const pageAction = get(event, 'page_action', get(event, 'pageAction'));

    return {
        ...venueData,
        eventSetting: {
            ...eventSettingsData,
            pagePrivacyType,
        },
        id,
        title,
        description,
        domain,
        customDomain,
        isRsvpOpen,
        startTime,
        endTime,
        rsvpMethod: pageAction,
        autosave,
        published,
        eventType: { name: eventType },
        whiteLabel,
        hideFooter,
        isHub,
    };
};
